import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  SubscriptionPlan,
  SubscriptionModal,
  MySubscriptionDetails,
  SelectedSubscriptionDetails,
} from "./type";

export const subscriptionInitialState: SubscriptionModal = {
  subscriptionListing: [],
  selectedSubscription: {
    plan: {
      _id: "",
      subscriptionPlan: "",
      durationInMonths: 0,
      amount: 0,
      description: "",
      planStatus: "",
      isArchived: false,
      planFeatures: [],
      createdAt: "",
      hasFreeTrial: false,
      billingCycle: "",
      freeTrialDuration: "",
      offerIdWithTrial: "",
      updatedAt: "",
      offerIdWithoutTrial: "",
    },

    primaryAccount: {
      source_id: "",
      user_id: "",
      is_primary: false,
      status: "",
      routing: "",
      bank: "",
      lbacc: "",
      type: "",
      created_at: "",
      updated: "",
      created: "",
    },

    manufacturer: {
      companyName: "",
      billingEmail: "",
      manufacturerId: "",
    },
  },

  mySubscriptionDetails: {
    _id: "",
    amount: 0,
    endDate: null,
    startDate: "",
    isActive: false,
    isCancelled: false,
    planDescription: "",
    subscriptionPlan: "",
    nextBillingDate: null,
    subscriptionStatus: "",
    subscriptionOfferId: "",
    subscriptionPlanId: "",
    hasUsedFreeTrial: false,
    isFreeTrialExpired: false,
    freeTrialRemainingDays: 0,
    subscriptionEnrollmentId: "",
    subscriptionRemainingDays: 0,
    subscriptionToken: "",
  },
};

const SubscriptionSlice = createSlice({
  name: "account",
  initialState: subscriptionInitialState,
  reducers: {
    setSubscriptionlistingData: (
      state: SubscriptionModal,
      action: PayloadAction<SubscriptionPlan[]>,
    ) => {
      state.subscriptionListing = { ...action.payload };
    },

    setSelectedSubscriptionDetails: (
      state: SubscriptionModal,
      action: PayloadAction<SelectedSubscriptionDetails>,
    ) => {
      state.selectedSubscription = action.payload;
    },

    clearSelectedSubscriptionDetails: (state: SubscriptionModal) => {
      state.selectedSubscription =
        subscriptionInitialState.selectedSubscription;
    },

    setMySubscriptionDetails: (
      state: SubscriptionModal,
      action: PayloadAction<MySubscriptionDetails>,
    ) => {
      state.mySubscriptionDetails = action.payload;
    },
  },
});

export const {
  setMySubscriptionDetails,
  setSubscriptionlistingData,
  setSelectedSubscriptionDetails,
  clearSelectedSubscriptionDetails,
} = SubscriptionSlice.actions;

export default SubscriptionSlice.reducer;
